import { useLayoutEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from 'store';

export const useAuthBackground = () => {
  const [backgroundImage, setBackgroundImage] = useState('');

  const {
    brandConfig: {
      config: {
        assets: {
          loginPictureUrl,
          loginPictureUrlLaptop,
          loginPictureUrlTablet,
          loginPictureUrlMobile,
        },
      },
    },
  } = useSelector((state: RootState) => state.settings);

  useLayoutEffect(() => {
    setBackground();

    window.addEventListener('resize', setBackground);

    return () => {
      window.removeEventListener('resize', setBackground);
    };
  }, []);

  const setBackground = () => {
    if (window.innerWidth > 1200) {
      setBackgroundImage(loginPictureUrl ? `url(${loginPictureUrl})` : '');
      return;
    }

    if (window.innerWidth > 1024) {
      setBackgroundImage(
        loginPictureUrlLaptop ? `url(${loginPictureUrlLaptop})` : ''
      );
      return;
    }

    if (window.innerWidth > 560) {
      setBackgroundImage(
        loginPictureUrlTablet ? `url(${loginPictureUrlTablet})` : ''
      );
      return;
    }

    setBackgroundImage(
      loginPictureUrlMobile ? `url(${loginPictureUrlMobile})` : ''
    );
  };

  return backgroundImage;
};
